import { render } from "./GuessNo.vue?vue&type=template&id=becbbebe&scoped=true"
import script from "./GuessNo.vue?vue&type=script&lang=js"
export * from "./GuessNo.vue?vue&type=script&lang=js"

import "./GuessNo.vue?vue&type=style&index=0&id=becbbebe&lang=stylus&scoped=true"

import exportComponent from "/Volumes/ZTDisk/Mx_Zone/projects/xs/labfront/node_modules/.pnpm/vue-loader@16.8.3_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@4.47.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-becbbebe"]])

export default __exports__